import useAccessControls from 'modules/access-controls/atoms/use-access-controls';
import useEditCategory, {
  EditCategoryProps,
} from 'modules/categories/hooks/use-edit-category';
import {translatedCategoryProps} from 'modules/categories/types';
import categoriesKeys from 'modules/categories/util/categories-keys';
import useCompaniesSelectData from 'modules/companies/hooks/use-companies-select-data';
import React from 'react';
import {useParams} from 'react-router-dom';
import Edition from 'shared/layout/edition';
import useFormInputs from 'shared/migration-components/form/util';

const EditCategory: React.FC = () => {
  const {id} = useParams();
  const {getInput, getSwitch, getSelect} = useFormInputs<EditCategoryProps>();
  const {data, isLoading} = useCompaniesSelectData();
  const {companyId} = useAccessControls();

  return (
    <Edition<EditCategoryProps>
      titleBar={{title: 'Editar categoria'}}
      inputs={[
        getInput({name: 'name'}),
        getSwitch({
          name: 'active',
        }),
        getSelect({
          name: 'companyId',
          data: data,
          isLoading,
          hidden: () => !!companyId,
        }),
      ]}
      detailsUrl={`/categories/${id}`}
      onSubmit={() => useEditCategory(id!)}
      translationKey={translatedCategoryProps}
      queryKey={categoriesKeys.details(id!)}
    />
  );
};

export default EditCategory;
